export const disposeMaterial = (material) => {
    const materials = Array.isArray(material) ? material : [material];

    for (const material of materials) {
        // Dispose textures in standard slots (e.g., map, normalMap)
        for (const key in material) {
            const value = material[key];
            if (value && value.isTexture) {
                value.dispose();
            }
        }

        // Dispose textures in custom shader uniforms
        if (material.uniforms) {
            for (const uniformName in material.uniforms) {
                const uniform = material.uniforms[uniformName];
                if (uniform && uniform.value && uniform.value.isTexture) {
                    uniform.value.dispose();
                }
            }
        }

        material.dispose();
    }
};
